// Models
import { UserModel } from '../../../shared/models';
import { CompanyUserToEditDto } from '../../company/models/company-user-to-edit-dto';
import { CompanyUser } from '../../company/models/company-user.model';

export namespace UserActions {
	export class GetAll {
		static readonly type = '[User] Get Users';
		constructor(public data: { showSpinner?: boolean; showToast?: boolean } = { showSpinner: false, showToast: false }) {}
	}

	export class SetAll {
		static readonly type = '[User] Set Users';
		constructor(public users: UserModel[]) {}
	}

	export class Create {
		static readonly type = '[User] Create User';
		constructor(public data: { user: UserModel; showSpinner?: boolean; showToast?: boolean } = { user: null, showSpinner: false, showToast: false }) {}
	}

	export class CreateSuccess {
		static readonly type = '[User] Create User Success';
		constructor(public user: UserModel) {}
	}

	export class CreateError {
		static readonly type = '[User] Create User Error';
	}

	export class Update {
		static readonly type = '[User] Update User';
		constructor(public data: { user: UserModel; showSpinner?: boolean; showToast?: boolean } = { user: null, showSpinner: false, showToast: false }) {}
	}

	export class UpdateSuccess {
		static readonly type = '[User] Update User Success';
		constructor(public user: UserModel) {}
	}

	export class UpdateError {
		static readonly type = '[User] Update User Error';
	}

	export class UpdateCompanyUser {
		static readonly type = '[User] Update Company User';
		constructor(public data: { companyUser: CompanyUserToEditDto; showSpinner?: boolean; showToast?: boolean } = { companyUser: null, showSpinner: false, showToast: false }) {}
	}

	export class UpdateCompanyUserSuccess {
		static readonly type = '[User] Update Company User Success';
		constructor(public companyUser: CompanyUser) {}
	}

	export class UpdateCompanyUserError {
		static readonly type = '[User] Update Company User Error';
	}

	export class Delete {
		static readonly type = '[User] Delete User';
		constructor(public data: { id: number; showSpinner: boolean; showToast?: boolean; showConfirm?: boolean } = { id: null, showSpinner: false, showToast: false, showConfirm: false }) {}
	}
}
